import type { Maybe } from '@vrplatform/utils';

export const isOpeningBalanceTransaction = (uniqueRef: Maybe<string>) => {
  const safeUniqueRef = uniqueRef || '';

  if (
    safeUniqueRef === 'openingBalance_advanceDeposits' ||
    safeUniqueRef === 'openingBalance_advancedDeposits'
  ) {
    return {
      type: 'advanceDeposits' as const,
    };
  }

  if (safeUniqueRef === 'openingBalance_taxPayable') {
    return {
      type: 'taxPayable' as const,
    };
  }

  if (safeUniqueRef.startsWith('openingBalance_listing_')) {
    return {
      type: 'listing' as const,
      listingId: safeUniqueRef.split('openingBalance_listing_').reverse()[0],
    };
  }

  return null;
};
